module.exports = function getResource(label, vars = []) {
    const resources = {
        userImage: 'image générée par l’utilisateur',
        postedIn: 'Publiée dans :',
        remove: 'Supprimer',
        areYouSure: 'Êtes-vous sûr de vouloir supprimer ce look? Une fois supprimé, le look et tous les détails qui y sont associés seront supprimés de façon permanente.',
        delete: 'Supprimer',
        cancel: 'Annuler',
        lookDeleted: 'Ce look a bien été supprimé. Veuillez patienter une heure avant que ce look ne soit supprimé.'
    };
    return resources[label];
};
